enum LayoutSources {
  INDEX = 'INDEX',
  POST = 'POST',
  ABOUT = 'ABOUT',
}

export default LayoutSources;
